<div class="container-fluid h-100 d-flex flex-column">
  <div class="page-head">
    <h1 class="page-title">Vendor Ratings</h1>
  </div>
  <div class="row flex-grow-1 mb-2">
    <div class="col">
      <app-company-vendors-grid
        [gridName]="'VendorRatings'"
        [suppliedQueryData]="SuppliedQueryData"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        (rowClick)="action({ action: 'view', rowData: $event.data })"
      ></app-company-vendors-grid>
    </div>
  </div>
</div>
